<div
  class="op-ian-item--row"
  (click)="onClick()"
  (dblclick)="onDoubleClick()"
  >
  @if (workPackage$ && (workPackage$ | async); as workPackage) {
    <div
      class="op-ian-item--top-line"
      >
      <div class="op-ian-item--status">
        <op-in-app-notification-status [status]="workPackage.status" />
      </div>
      <a
        class="op-ian-item--work-package-id-link spot-link"
        [class.spot-link_inactive]="isMobile()"
        [attr.title]="workPackage.subject"
        uiSref="work-packages.show"
        [uiParams]="{workPackageId: workPackage.id, projects: null, projectPath: null}"
        [textContent]="'#' + workPackage.id"
        >
      </a>
      @if (project) {
        <div
          class="op-ian-item--project"
          >
          - <a
          class="op-ian-item--project-link"
          [class.spot-link_inactive]="isMobile()"
          [href]="project.showUrl"
          [textContent]="project.title"
          (click)="projectClicked($event)"
          target="_blank"
        ></a> -
      </div>
    }
    <div class="op-ian-item--reason-wrapper">
      @for (item of translatedReasons | keyvalue; track item.key; let last = $last) {
        <span class="op-ian-item--reason">
          {{ item.key }}@if (!last) {, }
        </span>
      }
    </div>
  @if (!notification.readIAN) {
    <span
      class="op-ian-item--reason-count"
      [textContent]="aggregatedNotifications.length"
    ></span>
  }
  <div class="op-ian-item--buttons">
    @if (!notification.readIAN) {
      <i
        data-test-selector="mark-as-read-button"
        class="op-ian-item--button icon-mark-read"
        [title]="text.mark_as_read"
        (click)="markAsRead($event, aggregatedNotifications)"
        tabindex="0"
        >
      </i>
    }
    <i
      class="op-ian-item--button op-ian-item--button_shown-on-focus icon-info1"
      (keydown.enter)="showDetails()"
      tabindex="0"
      >
    </i>
  </div>
</div>
<div
  class="op-ian-item--middle-line"
  >
  <span
    [ngClass]="'op-ian-item--work-package-type __hl_inline_type_' + workPackage.type.id"
    [textContent]="workPackage.type.name">
  </span>
  <span
    [textContent]="workPackage.subject"
    class="op-ian-item--work-package-subject"
    [class.-read]="notification.readIAN"
    >
  </span>
</div>
<div
  class="op-ian-item--bottom-line"
  >
  @if (hasReminderAlert) {
    <op-in-app-notification-reminder-alert
      [aggregatedNotifications]="aggregatedNotifications"
      />
  }
  @if (!hasReminderAlert) {
    @if (showDateAlert) {
      <op-in-app-notification-date-alert [aggregatedNotifications]="aggregatedNotifications"
       />
    }
    @if (!showDateAlert) {
      <op-in-app-notification-actors-line [notification]="notification"
        [aggregatedNotifications]="aggregatedNotifications"
       />
    }
  }
</div>
} @else {
  <div class="op-ian-item--loading">
    @if (workPackage$) {
      <op-content-loader
        class="op-ian-item--loading-indicator"
        viewBox="0 0 200 20"
        >
        <svg:rect x="0" y="0" width="100%" height="5" rx="1" />
        <svg:rect x="0" y="7" width="100%" height="5" rx="1" />
        <svg:rect x="0" y="14" width="80%" height="5" rx="1" />
      </op-content-loader>
    }
    <span class="op-ian-item--reason-count"></span>
    <div class="op-ian-item--buttons">
      <i class="op-ian-item--button icon-mark-read">
      </i>
    </div>
  </div>
}
</div>
